module.exports = __webpack_public_path__ + "img/logo.5f867886.png";